//import moment from "moment";
import { Fragment, useEffect, useState } from "react";
import { useAsync } from "react-async";
import { EntryTypes, TaskTypeLookup, BillToLookup } from '../../common/constants';
import { validateEntryMinutesForDay } from './shared';
import { Moment } from "moment";
import moment from "moment";
import DayEntry from "./types/dayEntry";
import TimesheetTaskEntries from "./types/timesheetTaskEntries";
import EditEntryModalProps from "./types/editEntryModal";
import { getTaskType } from "../../api/services/taskTypeService";
import { getTherapistPeriodDistrictProgramOptions } from "../../api/services/districtService";
import DistrictProgramSelectOption from "./types/districtProgramSelectOption";
import DistrictsProgramOptionsResponse from "../../api/responses/districtProgramOptionsResponse";
import Spinner from "../spinner";
/**
 * Displays the time entry for editing existing entries 
 * @param param0 
 * @returns 
 */
const getDistrictProgramOptionsPromise = async (args: any) => {
    return getTherapistPeriodDistrictProgramOptions(args[0], args[1], args[2]);
}

const EditEntry = ({ entryState, setEntryState, editNote, setHasChanges }: EditEntryModalProps) => {
    const [entries, setEntries] = useState<DayEntry[]>(entryState.timesheetEntries ?? []);
    //validation
    const [validationMsg, setValidationMsg] = useState<string | null | JSX.Element>();
    const [entryWithError, setEntryWithError] = useState<number>(-1);
    const [recoupment, setRecoupment] = useState<boolean>(entries.some(x => x.recoupment) ?? false);
    const [timesheetEntryTasks, setTimesheetEntryTasks] = useState<TimesheetTaskEntries[]>(entryState.timesheetEntryTasks ?? []);
    const [districtProgramOption, setDistrictProgramOption] = useState<DistrictProgramSelectOption>();


    const taskTypeId = entryState.taskTypeId;

    const loadDistrictProgramOptions = useAsync({
        deferFn: getDistrictProgramOptionsPromise,
        onResolve: (response: DistrictsProgramOptionsResponse) => {
            if (response) {
                let options = [] as DistrictProgramSelectOption[];
                response.data?.districts.forEach((district, i) => options.push({ districtId: district.districtId ?? -1, label: district.name, programId: district.programId ?? -1, payrates: district.payrates ?? [] }));
                let result = options.find(option => {
                    if (entryState.programId !== null) {
                        return option.districtId === entryState.districtId && option.programId === entryState.programId;
                    }
                    return option.districtId === entryState.districtId;
                });
                setDistrictProgramOption(result);
            }
        },
    });
    //When the edit entry dialog first loads, indicate we have changes
    useEffect(() => {
        loadDistrictProgramOptions.run(entryState.startDate.toLocaleString(), entryState.endDate.toLocaleString(), entryState.disciplineId);
        setHasChanges(true);
    }, []);

    /**
     * Update the timesheet entry when a new entry is added or one is updated
     * @param index 
     * @param inputMinutes 
     * @param dateOfEntry 
     * @returns 
     */
    const updateEntryTime = (index: number, inputMinutes: number, dateOfEntry?: Date | Moment) => {
        //First, we need to check if this is an edit or an add
        const entry = timesheetEntryTasks[0].entries[index];

        timesheetEntryTasks[0].entries[index].minutes = inputMinutes;
        //Create a new entries array
        const newEntries = [...timesheetEntryTasks[0].entries];

        //If the entry exists, process the edit
        if (entry) {
            //if there is a validation error users can't add more time to other entries, but they are allowed to reduce, otherwise they can't change anything
            // if (entryState.hasValidationErrors && (newEntries && newEntries[index] && (newEntries[index].minutes ?? 0) < inputMinutes)) {
            //     alert("You have validation errors, please fix those issues before adjusting other entries");
            //     return;
            // }

            //check's validation, set's the validation message to the result of the validation
            setValidationMsg(validateEntryMinutesForDay(entryState, newEntries, inputMinutes));

            //Set the timesheet task entries
            const tmpTasks: TimesheetTaskEntries[] = [];
            setTimesheetEntryTasks(entryTask => {
                //Loop through each entry task
                const tmpEntryTask = [...entryTask];
                tmpEntryTask.map(task => {
                    //Update the entry
                    const tmpTask = { ...task };
                    tmpTask.entries[index].minutes = inputMinutes;
                    tmpTask.entries[index].markAsDeleted = false;
                    tmpTask.entries[index].recoupment = timesheetEntryTasks[0].entries.some(x => x.recoupment) ?? timesheetEntryTasks[0].entries[index].recoupment;
                    tmpTask.entries[index].makeupTime = timesheetEntryTasks[0].entries.some(x => x.makeupTime || x.isMakeupTime) ?? timesheetEntryTasks[0].entries[index].makeupTime ?? timesheetEntryTasks[0].entries[index].isMakeupTime;
                    var existingTaskType = tmpTasks.find(x => x.taskTypeId === task.taskTypeId && x.billToId === task.billToId);
                    if (existingTaskType) {
                        existingTaskType = tmpTask;
                    } else {
                        tmpTasks.push(tmpTask);
                    }
                    return tmpTask;
                });

                return tmpEntryTask;
            });

            //Update the entry state
            setEntryState(entryState => {
                const tmpEntryState = { ...entryState };
                tmpEntryState.timesheetEntryTasks = tmpTasks;
                return tmpEntryState;
            });

            //Return early
            return;
        }

        //Otherwise, we add a new entry
        const newEntry: DayEntry = {
            notes: '',
            dateOfEntry: moment(dateOfEntry),
            date: moment(dateOfEntry),
            enabled: true,
            minutes: inputMinutes,
            recoupment: timesheetEntryTasks[0].entries.some(x => x.recoupment) ?? recoupment ?? false,
            makeupTime: timesheetEntryTasks[0].entries.some(x => x.makeupTime || x.isMakeupTime) ?? false,
        }

        //Add the new entry to the array
        newEntries.push(newEntry);

        //Set the timesheet entry tasks
        setTimesheetEntryTasks(current => {
            const tmpCurrent = [...current];
            tmpCurrent.map(task => task.entries = newEntries)
            return tmpCurrent;
        });

        //Update the entry state with the new tasks
        setEntryState(entryState => {
            const tmpEntryState = { ...entryState };
            if (tmpEntryState.timesheetEntryTasks !== undefined) {
                tmpEntryState.timesheetEntryTasks.map(task => task.entries = newEntries);
            }
            return tmpEntryState;
        });
    }

    /**
     * Toggles the "Absence" or "Unavailable entries". They don't have time associated with them.
     * minutes = undefined: unchecked
     * minutes = 0: checked
     * @param index 
     */
    const toggleNonTimeEntries = (index: number) => {
        const entryTasks = [...timesheetEntryTasks];

        //Loop through the entries and set the minutes
        entryTasks.map(entryTask => entryTask.entries.map((entry, i) => {
            //If not the correct index, escape
            if (i !== index) return entry;

            entry.minutes = entry.minutes === undefined ? 0 : undefined;
            return entry;
        }));

        //Update state
        entryState.timesheetEntryTasks = entryTasks;
        setTimesheetEntryTasks(entryTasks);
    }

    /**
     * When the user wants to see or update notes for a day of the week
     * @param index 
     */
    const editNoteClicked = (index: number) => {
        entryState.timesheetEntries = entries;

        //reset the state of the validtion errors, they will be checked again with this component loads
        entryState.hasValidationErrors = false;
        setValidationMsg(null);

        editNote({
            dayEntry: timesheetEntryTasks[0].entries![index],
            entryModel: entryState,
            taskTypeId,
            isRecoupment: timesheetEntryTasks[0].entries![index].recoupment,
            isMakeupTime: timesheetEntryTasks[0].entries![index].isMakeupTime
        });
    }

    /**
     * This will revalidate each entry after the user edit notes
     */
    useEffect(() => {
        setValidationMsg(null);
        setEntryWithError(-1);
        entryState.existingMinutesEntered = 0; //this was throwing off the validation logic. 
        if (entries != undefined) {
            const entriesUpdate: any = entryState.timesheetEntryTasks?.length != 0 ? entryState.timesheetEntryTasks![0]?.entries : entries;
            for (var i = 0; i < entriesUpdate.length; i++) {
                if (entriesUpdate[i].minutes != undefined) {

                    var msg = validateEntryMinutesForDay(entryState, entriesUpdate, entriesUpdate[i].minutes!);
                    if (msg != null) {
                        setValidationMsg(msg);
                        setEntryWithError(i);
                        break;
                    }
                }
            }
        }
    }, []);

    /**
     * Will mark the entry as deleted, remove the minutes and
     * disable it so it will update the UI elements
     * @param index Index of the timesheet entry
     */
    const handleDeleteEntry = (index: number) => {
        if (timesheetEntryTasks[0] && timesheetEntryTasks[0].entries && timesheetEntryTasks[0].entries[index]) {
            timesheetEntryTasks[0].entries[index].markAsDeleted = true;
            timesheetEntryTasks[0].entries[index].enabled = false;
            timesheetEntryTasks[0].entries[index].notes = '';
            timesheetEntryTasks[0].entries[index].minutes = undefined;

            updateEntryState(entries);
            setValidationMsg(validateEntryMinutesForDay(entryState, entries, 0));
        }
    }

    /**
     * Updates the entry state so all UI components update
     */
    const updateEntryState = (newEntries: DayEntry[] | undefined = undefined) => {
        //update state
        newEntries = newEntries ?? entries;
        entryState.timesheetEntries = newEntries;
        setEntryState(entryState);
        setEntries([...newEntries]);
    }

    /**
     * Non Student Billing Type Sync
     * This effect will make sure the billing type id is set properly.
     * This should only happen when editing non student entries
     */
    useEffect(() => {
        if (entryState.entryTypeId === EntryTypes.NonStudent &&
            entryState.selectedTimesheet?.items.find(x => x.billToId)?.billToId !== null &&
            entryState.selectedTimesheet?.items.find(x => x.billToId)?.billToId !== undefined) {
            const billingTypeId = entryState.taskTypeId != TaskTypeLookup.Other ? BillToLookup.School : (entryState.schoolId ? BillToLookup.School : BillToLookup.District);
            entryState.billToId = billingTypeId;
            setEntryState(entryState);
        }
    }, [entryState]);

    /**
     * On initial load, processes the existing timesheet entries
     */
    useEffect(() => {
        if (timesheetEntryTasks.length === 0) {
            const entry = entryState.timesheetEntries?.find(x => x.timesheetEntryId && x.timesheetEntryId > 0);

            getTaskType(entryState.taskTypeId!).then(result => {
                let taskType = result.data?.taskType;

                //Loop through the timesheet entries so we can get the correct entry id, minutes, recoupment and makeup time properties
                const timesheetEntries: DayEntry[] = [];
                entryState.selectedTimesheet?.items.forEach(item => {
                    item.tasks.forEach(task => {
                        const taskEntry = task.entries.find(x => x.entryId === entry?.entryId || x.timesheetEntryId === entry?.timesheetEntryId);
                        if (taskEntry && timesheetEntries !== undefined) {
                            entryState.timesheetEntries?.map(x => {
                                //If the timesheet entry id is equal to the one we found earlier, add this custom DayEntry
                                //This one includes the entry id and makeup time properties
                                if (x.timesheetEntryId === taskEntry.timesheetEntryId || x.entryId === taskEntry.entryId) {
                                    const e: DayEntry = {
                                        entryId: x.timesheetEntryId,
                                        minutes: x.minutes ?? undefined,
                                        notes: x.notes,
                                        dateOfEntry: moment(x.date ?? x.dateOfEntry),
                                        recoupment: taskEntry.recoupment,
                                        makeupTime: taskEntry.makeupTime,
                                        markAsDeleted: x.markAsDeleted,
                                        schoolId: x.schoolId,
                                        enabled: x.enabled
                                    };
                                    timesheetEntries.push(e);
                                    return e;
                                }

                                //Otherwise just push this one
                                timesheetEntries.push(x);
                                return x;
                            });
                        }
                    });
                });

                //Now we create the task entry
                //We also loop through the entries and return a properly formatted DayEntry
                const tmpTasks: TimesheetTaskEntries[] = [{
                    taskType: taskType,
                    taskTypeId: entryState.taskTypeId,
                    entries: timesheetEntries?.map(entry => {
                        return {
                            entryId: entry.entryId ?? entry.timesheetEntryId,
                            minutes: entry.minutes ?? undefined,
                            notes: entry.notes,
                            dateOfEntry: moment(entry.date ?? entry.dateOfEntry),
                            timesheetEntryFlags: [],
                            recoupment: entry.recoupment,
                            isMakeupTime: entry.makeupTime,
                            markAsDeleted: entry.markAsDeleted,
                            enabled: entry.enabled
                        } as DayEntry;
                    }) ?? [],
                    billToId: entryState.billToId,
                    startDate: entryState.startDate,
                    schoolId: entryState.schoolId,
                    endDate: entryState.endDate,
                }];

                setTimesheetEntryTasks(tmpTasks);
                entryState.timesheetEntryTasks = tmpTasks;
                setEntryState(entryState);
            })
        }
    }, []);

    return (

        <Fragment>
            {<Spinner show={loadDistrictProgramOptions.isPending} />}
            {!loadDistrictProgramOptions.isPending &&
                (timesheetEntryTasks ?? []).map(entryTask => {

                    return (
                        <div key={`edit-entry-task-${entryTask.taskTypeId ?? TaskTypeLookup.Other}`} className="flex flex-row w-full mt-2 justify-evenly">
                            {entryTask.entries!.map((entry, i) => {
                                const dateOfEntry = moment(entry.dateOfEntry ?? entry.date);
                                const payrateExists = districtProgramOption?.payrates!.some(pr => {
                                    if (!pr.payrateStartDate) return false;
                                    const start = moment(pr.payrateStartDate);
                                    const end = pr.payrateEndDate ? moment(pr.payrateEndDate) : moment(); 
                                    if (!start.isValid() || !end.isValid()) return false;
                                    return dateOfEntry.isBetween(start, end, undefined, '[]');
                                }) ?? false;
                                const isDisabled = !(!moment().isBefore(dateOfEntry) && payrateExists);
                                return (
                                    <div key={`edit-entry-task-${entryTask.taskTypeId ?? TaskTypeLookup.Other}-${entry.timesheetEntryId}-${dateOfEntry.format('YYYY-MM-DD')}`} className="w-20 text-center">
                                        {/* Day Name */}
                                        <div className={`font-bold ${isDisabled ? "text-gray-300" : ""}`}>
                                            {dateOfEntry.format('ddd')}
                                        </div>

                                        {/* Date Number */}
                                        <div className={`text-xs mb ${isDisabled ? "text-gray-300" : ""}`}>
                                            {dateOfEntry.format('M/D')}
                                        </div>

                                        {/* Unavailable/Absence Checkbox */}
                                        {(taskTypeId === TaskTypeLookup.Unavailable || taskTypeId === TaskTypeLookup.Absence) && (
                                            <input
                                                type="Checkbox"
                                                checked={entry?.minutes !== undefined}
                                                disabled={isDisabled}
                                                onChange={(e) => toggleNonTimeEntries(i)}
                                            />
                                        )}

                                        {/* Textbox */}
                                        {taskTypeId !== TaskTypeLookup.Unavailable && taskTypeId !== TaskTypeLookup.Absence && (
                                            <input
                                                className={`inline-block text-center rounded-md h-12 w-12 appearance-none border mb-1 ${(i == entryWithError) ? "border-red-700" : ""} ${entry.enabled ? "border-black" : "border-slate-100 bg-slate-900"}`}
                                                value={entry.minutes ? entry.minutes.valueOf() : "" ?? ""}
                                                disabled={isDisabled}
                                                onChange={(e) => updateEntryTime(i, Number(e.target.value.replace(/\D/g, "")), entry.dateOfEntry)}
                                            />
                                        )}

                                        {/* Add/Edit Note Link */}
                                        {entry.minutes !== undefined && entry.minutes !== null && entry.minutes !== 0 &&

                                            !(taskTypeId === TaskTypeLookup.Direct && !entry.recoupment && !entry.isMakeupTime) &&
                                            <div className="cursor-pointer text-ptsblue-dark" onClick={(e) => { editNoteClicked(i); }}>
                                                {(entry.notes.length === 0) ? "Add Note" : "Edit Note"}
                                            </div>}

                                        {/* Delete Link */}
                                        {entry.minutes !== undefined && entry.minutes !== null && entry.minutes !== 0 &&

                                            taskTypeId !== TaskTypeLookup.Unavailable && taskTypeId !== TaskTypeLookup.Absence &&
                                            <div
                                                className="cursor-pointer text-ptsblue-dark"
                                                onClick={() => handleDeleteEntry(i)}
                                            >Delete</div>
                                        }
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}

            {validationMsg != null && !recoupment && typeof validationMsg === "string" && (
                <div className="text-sm text-red-900">{validationMsg}</div>
            )}

            {validationMsg != null && !recoupment && typeof validationMsg !== "string" && validationMsg}
        </Fragment>

    );
}

export default EditEntry;